import { IAlternativeUpload } from '@printdeal/alternative-upload';
import { QuoteAttachmentInfo } from '../../../../../types/quotes/quoteRequest';

export interface QuoteFormValues {
  reference: string;
  attachment?: QuoteAttachmentInfo[];
  description: string;
}

export const getAttachmentInfo = (fileInfo: IAlternativeUpload[]) => fileInfo.map((fileInformation) => {
  const { urls, id: fileId, uploadTitle } = fileInformation;
  const fileUrl = urls?.originalUrl || '';
  const fileType = uploadTitle.substring(uploadTitle.lastIndexOf('.'));

  if (fileId && fileType && fileUrl !== '') {
    return { fileId, fileType, fileUrl };
  }
  return null;
}).filter(Boolean) as QuoteAttachmentInfo[];

export const createQuotePayload = ({ reference, attachment = [], description }: QuoteFormValues) =>

  ({
    quoteLineItems: [
      {
        description,
        quantity: '0',
      },
    ],
    reference,
    attachment,
  });
